import React, { ReactNode } from 'react';

const InformationPanel: React.FC<{ children: ReactNode }> = ({ children }) => {
	return (
		<div className="flex justify-center max-w-4xl px-4 py-6 lg:px-6 w-full bg-neutral rounded-2xl">
			<div className="text-center text-font text-lg max-w-3xl">{children}</div>
		</div>
	);
};

export default InformationPanel;
